'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _readmissions = require('./readmissions.component');

var _readmissions2 = _interopRequireDefault(_readmissions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var readmissionsModule = _angular2.default.module('readmissions', [_angularUiRouter2.default]).component('readmissions', _readmissions2.default);

exports.default = readmissionsModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/readmissions/readmissions.js